import { r as registerInstance, h, H as Host } from './index-dba4409d.js';

const ProactiveCaseClosureModal = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.successMessageWasShown = false;
        this.handleClose = () => {
            this.modal.triggerClose();
        };
        this.handleModalClose = () => {
            if (this.successMessageWasShown) {
                window.location.reload();
            }
        };
        this.callId = undefined;
        this.locale = undefined;
        this.modalName = undefined;
        this.env = "prod";
        this.legacyApi = false;
        this.debug = false;
    }
    render() {
        return (h(Host, { key: '626cc35908ffe8504260c4d60476ff5a4d85d1a6' }, h("ux-modal", { key: '3bef3d7b266b619b681b8462403c29bbe5c5bc95', onUxModalClose: () => this.handleModalClose(), name: this.modalName, ref: (el) => (this.modal = el) }, h("ux-modal-content", { key: '886f5fb3f9e86946604548a59042c969f435d251' }, h("mf-proactive-case-closure", { key: '4833326e87dfcf4df59f703e281d37307185ccb2', callId: this.callId, locale: this.locale, onMfServiceCallCancel: () => this.handleClose(), onMfServiceCallSuccess: () => {
                this.handleClose();
                window.location.reload();
            }, onMfServiceCallShowSuccess: () => (this.successMessageWasShown = true), env: this.env, legacyApi: this.legacyApi, debug: this.debug })))));
    }
};

export { ProactiveCaseClosureModal as mf_proactive_case_closure_modal };

//# sourceMappingURL=mf-proactive-case-closure-modal.entry.js.map